import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ApicallService } from '../services/apicall.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard  {
  user: Object;

  constructor(
    private authService: AuthService,
    public apiCallService: ApicallService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.apiCallService.loggedIn() && this.apiCallService.user == undefined) {
      this.apiCallService.loadUser();
      this.apiCallService.loadPath();
      this.apiCallService.loadToken();
    }

    let expectedPermissionArray = route.data.permission;
    let permissionArray = this.apiCallService.permissions;
    let permissionString;

    let expectedPermission = false;
    if (permissionArray == undefined)
      permissionArray = [];

    for (let i = 0; i < expectedPermissionArray.length; i++) {
      for (let j = 0; j < permissionArray.length; j++) {
        if (expectedPermissionArray[i] == permissionArray[j]) {
          permissionString = expectedPermissionArray[i];
          expectedPermission = true;
          break;
        }
      }
    }
    
    if (this.authService.isAuthenticated() && expectedPermission === true) {
      if (this.apiCallService.user.roles[0].type === 'agent' || this.apiCallService.user.roles[0].type === 'child-agent') {
        if (this.apiCallService.user.is_urd_acknowlege || this.apiCallService.user.agentType=='I') {
          return true;
        }
        else {
          this.router.navigate(['/urd-acknowledge-page']);
          return false;
        }
      } else {
        return true;
      }

    } else {
      this.router.navigate(['/permission-denied']);
      return false;
    }
  }
}
